import { getChallenge, initUploadFile } from 'client/actions/api';
import type { FormDataT } from 'client/components/common/StoryCard/Form/types';
import { uploadToS3 } from 'src/routes/client/utils/upload-to-s3';
import { appLog } from 'utils/logger';

import type { HandleThunkActionCreator } from 'react-redux';
import { findNonce } from './utils';

const log = appLog.extend('file-upload-to-bucket');

export type FileItem = FormDataT['fieldId'] & { id: string };

interface UploadParams {
	storyId: string;
	cardId: string;
	getChallengeFn: HandleThunkActionCreator<typeof getChallenge>;
	initUploadFileFn: HandleThunkActionCreator<typeof initUploadFile>;
}

export async function uploadFormFiles(fileItems: FileItem[], params: UploadParams): Promise<FileItem[]> {
	const { storyId, cardId, getChallengeFn, initUploadFileFn } = params;
	const challenge = await getChallengeFn({ type: 'high' });

	if (!challenge) {
		throw new Error('Challenge not found');
	}

	const nonce = findNonce(challenge.prefix, challenge.difficulty);

	const results = await Promise.all(
		fileItems.map(async (item): Promise<FileItem> => {
			const initResult = await initUploadFileFn(
				{ storyId, cardId, inputId: item.id },
				{
					contentType: item.file?.type ?? '',
					size: item.file?.size ?? 0,
					challenge: { id: challenge.id, nonce },
				}
			);

			if (!initResult) {
				throw new Error(`Init upload failed for input "${item.id}"`);
			}

			const uploadResult = await uploadToS3(item.file!, initResult);
			log(`uploadResult for ${item.id}`, uploadResult);

			return {
				...item,
				data: uploadResult,
			};
		})
	);

	return results;
}
